module.exports = __webpack_public_path__ + "static/media/agencias.7d25f1df.png";